import styles from "./TopBanner.module.scss";

import { ESIInclude } from "@packages/esi-include/ESIInclude";
import { useFeatureFlags } from "@/flags/flags";
import { useRouteParams } from "@/hooks/useRouteParams";
import { StandardProps } from "@/types/types";
import { shouldShowTopBanner } from "@/utils/banners";

export function TopBanner({
  productListingData,
}: Pick<StandardProps, "productListingData">) {
  const { pageType } = useRouteParams();
  const { isTopBannerFeatureFlagOn } = useFeatureFlags();

  const bannerId = productListingData.banners?.topBannerId;

  if (
    !isTopBannerFeatureFlagOn?.value ||
    !shouldShowTopBanner(pageType, bannerId)
  ) {
    return null;
  }

  return (
    <aside
      aria-label="Banner"
      data-testid="top-banner-container"
      className={styles.topbanner}
    >
      <ESIInclude
        src={`/content-renderer/banners/${bannerId}?no-failure=true&includeCoreCss=false&includeCoreJS=false&includePolyfills=false`}
        id="top-banner"
      />
    </aside>
  );
}
